import styled from "styled-components"

export const FavoriteFoodsWrapper = styled.div`
  --my-food-top-navigation-height: 46.4px;
  height: calc(100% - var(--my-food-top-navigation-height));
  overflow-y: auto;
`
export const Title = styled.div`
  line-height: 22px;
  padding: 8px;
  font-size: 14px;
  font-weight: 700;
  padding: 0 var(--app-horizontal-padding);
`

export const FavoriteMealsContent = styled.div`
  --title-height: 22px;
  overflow-y: auto;
  height: calc(100% - var(--title-height));
  padding: 0 var(--app-horizontal-padding);
`
